import { baseApi, defaultQueryFreshness } from "./baseApi";

export const moderationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    reportUser: builder.mutation<unknown, { reporterId: string; targetUserId: string; reason: string; details: string }>({
      query: ({ reporterId, targetUserId, reason, details }) => ({
        url: "/users/report",
        method: "POST",
        data: { reporterId, targetUserId, reason, details },
      }),
      invalidatesTags: [{ type: "Moderation", id: "LIST" }],
    }),
    blockUser: builder.mutation<unknown, { userId: string; targetUserId: string }>({
      query: ({ userId, targetUserId }) => ({ url: "/users/block", method: "POST", data: { userId, targetUserId } }),
      invalidatesTags: (_res, _err, { userId }) => [{ type: "Moderation", id: `blocked:${userId}` }],
    }),
    unblockUser: builder.mutation<unknown, { userId: string; targetUserId: string }>({
      query: ({ userId, targetUserId }) => ({ url: "/users/unblock", method: "POST", data: { userId, targetUserId } }),
      invalidatesTags: (_res, _err, { userId }) => [{ type: "Moderation", id: `blocked:${userId}` }],
    }),
    getBlockedUsers: builder.query<unknown, string>({
      query: (userId) => ({ url: `/users/${userId}/blocked`, method: "GET" }),
      providesTags: (_res, _err, userId) => [{ type: "Moderation", id: `blocked:${userId}` }],
      ...defaultQueryFreshness,
    }),
    isUserBlocked: builder.query<unknown, { userId: string; targetUserId: string }>({
      query: ({ userId, targetUserId }) => ({ url: `/users/${userId}/is-blocked/${targetUserId}`, method: "GET" }),
      providesTags: (_res, _err, { userId, targetUserId }) => [{ type: "Moderation", id: `isBlocked:${userId}:${targetUserId}` }],
      ...defaultQueryFreshness,
    }),
    requestAccountDeletion: builder.mutation<unknown, string>({
      query: (userId) => ({ url: `/users/${userId}/delete-request`, method: "POST" }),
      invalidatesTags: [{ type: "Moderation", id: "LIST" }],
    }),
    cancelAccountDeletion: builder.mutation<unknown, string>({
      query: (userId) => ({ url: `/users/${userId}/cancel-deletion`, method: "POST" }),
      invalidatesTags: [{ type: "Moderation", id: "LIST" }],
    }),
  }),
});

export const {
  useReportUserMutation,
  useBlockUserMutation,
  useUnblockUserMutation,
  useGetBlockedUsersQuery,
  useIsUserBlockedQuery,
  useRequestAccountDeletionMutation,
  useCancelAccountDeletionMutation,
} = moderationApi;
